var ParameterValueClass = (function () {
    function ParameterValueClass() {
    }
    return ParameterValueClass;
}());
//# sourceMappingURL=ParameterValueClass.js.map